<template>
    <div>

        <div class="my-2 flex items-center">
            <div class="mr-4">Border Radius</div>
            <select id="styleOptions" v-model="selectedBorderOption" @change="onBorderSelected"
                    class="border-gray-200 rounded py-1">
                <option v-for="borderOption in borderOptions">{{ borderOption }}</option>
            </select>

            <div class="mx-4">Font Weight</div>
            <select id="fontWeightOptions" v-model="selectedFontWeightOptions" @change="onFontWeightSelected"
                    class="border-gray-200 rounded py-1">
                <option v-for="fontWeightOption in fontWeightOptions">{{ fontWeightOption }}</option>
            </select>

            <div class="mx-4">Gradient Direction</div>
            <select id="gradientOptions" v-model="selectedGradientOption" @change="onGradientSelected"
                    class="border-gray-200 rounded py-1">
                <option v-for="gradientOption in gradientOptions">{{ gradientOption }}</option>
            </select>
        </div>

        <div v-for="(color, index) in colorNames" class="flex items-center my-4">
            <div class="w-20 mx-1 font-bold text-xl tracking-tight" :class="`text-${color}-500`">{{ color }}</div>
            <button class="mx-1 px-10 py-2" :class="darkClasses(color)" @click="onButtonClick(darkClasses(color))">Dark</button>
            <button class="mx-1 px-8 py-2" :class="brightClasses(color)" @click="onButtonClick(brightClasses(color))">Bright</button>
            <button class="mx-1 px-8 py-2" :class="lightClasses(color)" @click="onButtonClick(lightClasses(color))">Light</button>
            <button class="mx-1 px-5 py-2" :class="gradientClasses(color)" @click="onButtonClick(gradientClasses(color))">Mono Gradient</button>
            <button class="mx-1 px-5 py-2" :class="twoColorGradientClasses(color, index)" @click="onButtonClick(twoColorGradientClasses(color, index))">Dual Gradient</button>
            <button class="mx-1 px-5 py-2" :class="threeColorGradientClasses(color, index)" @click="onButtonClick(threeColorGradientClasses(color, index))">Tri Gradient</button>
            <button class="mx-1 px-5 py-2" :class="threeColorGradientClasses2(color, index)" @click="onButtonClick(threeColorGradientClasses2(color, index))">Tri Gradient +2</button>
        </div>

        <div v-for="(color, index) in neutralColorNames" class="flex items-center my-4">
            <div class="w-20 mx-1 font-bold text-xl tracking-tight" :class="`text-${color}-500`">{{ color }}</div>
            <button class="mx-1 px-10 py-2" :class="darkClasses(color)" @click="onButtonClick(darkClasses(color))">Dark</button>
            <button class="mx-1 px-10 py-2" :class="neutralDarkClasses(color)" @click="onButtonClick(neutralDarkClasses(color))">Mid</button>
            <button class="mx-1 px-8 py-2" :class="brightClasses(color)" @click="onButtonClick(brightClasses(color))">Neutral</button>
            <button class="mx-1 px-8 py-2" :class="lightClasses(color)" @click="onButtonClick(lightClasses(color))">Light</button>
            <button class="mx-1 px-5 py-2" :class="gradientClasses(color)" @click="onButtonClick(gradientClasses(color))">Mono Gradient</button>
        </div>

        <div class="flex items-center my-4">
            <div class="w-20 mx-1 font-bold text-xl tracking-tight">white</div>
            <button :class="buttonClasses" class="border border-zinc-200 bg-white text-black shadow-xl"
                    @click="onButtonClick('border border-zinc-200 bg-white text-black shadow-xl')">White</button>
        </div>

        <div class="flex items-center my-4">
            <div class="w-20 mx-1 font-bold text-xl tracking-tight">black</div>
            <button :class="buttonClasses" class="bg-black text-white"
                    @click="onButtonClick('bg-black text-white')">Black</button>
        </div>

    </div>
</template>

<script>
import ColorUtil from "../../app/utils/ColorUtil";
import StringUtil from "../../app/utils/StringUtil";
import BackgroundClassUtil from "../utils/BackgroundClassUtil";

export default {
    name: 'ButtonStyleExplorer',
    computed: {
        buttonClasses() {
            let classes = ['mx-1', 'px-10', 'py-2', this.borderRadius, this.fontWeight]
            return classes
        }
    },
    data() {
        return {
            model: webase.model,
            colorNames: new ColorUtil().tailwindBrightColors(),
            neutralColorNames: new ColorUtil().tailwindNeutralColors(),
            colors: new ColorUtil().tailwindColors(),
            bgClassUtil: new BackgroundClassUtil(),
            borderRadius: 'rounded-lg',
            fontWeight: 'font-medium',
            gradientDirection: 'bg-gradient-to-r',
            selectedBorderOption: 'lg',
            borderOptions: Object.keys({
                "none": "0px",
                "sm": "0.125rem",
                "DEFAULT": "0.25rem",
                "md": "0.375rem",
                "lg": "0.5rem",
                "xl": "0.75rem",
                "2xl": "1rem",
                "3xl": "1.5rem",
                "full": "9999px"
            }),
            selectedFontWeightOptions: 'normal',
            fontWeightOptions: Object.keys({
                "thin": "100",
                "extralight": "200",
                "light": "300",
                "normal": "400",
                "medium": "500",
                "semibold": "600",
                "bold": "700",
                "extrabold": "800",
                "black": "900"
            }),
            selectedGradientOption: 'gradient-to-r',
            gradientOptions: Object.keys({
                "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
                "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
                "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
                "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
                "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
                "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
                "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
                "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
            })
        }
    },
    mounted() {
        console.log(new ColorUtil().tailwindBrightColors())
    },
    methods: {
        onButtonClick(buttonClasses) {
            this.$emit('buttonSelected', `px-8 py-2 ${buttonClasses}`);
        },
        colorLabel(colorName) {
            return new StringUtil().titleCase(colorName)
        },
        lightClasses(colorName) {
            return `${this.bgClassUtil.lightClasses(colorName)} ${this.borderRadius} ${this.fontWeight} shadow-xl`
        },
        brightClasses(colorName) {
            return `${this.bgClassUtil.brightClasses(colorName)}  ${this.borderRadius} ${this.fontWeight}`
        },
        darkClasses(colorName) {
            return `${this.bgClassUtil.darkClasses(colorName)}  ${this.borderRadius} ${this.fontWeight}`
        },
        neutralDarkClasses(colorName) {
            return `${this.bgClassUtil.neutralDarkClasses(colorName)}  ${this.borderRadius} ${this.fontWeight}`
        },
        gradientClasses(colorName) {
            return `${this.gradientDirection} ${this.bgClassUtil.gradientClasses(colorName)} ${this.borderRadius} ${this.fontWeight}`
        },
        twoColorGradientClasses(colorName, index) {
            return `${this.gradientDirection} ${this.bgClassUtil.twoColorGradientClasses(colorName, index)} ${this.borderRadius} ${this.fontWeight}`
        },
        threeColorGradientClasses(colorName, index) {
            return `${this.gradientDirection} ${this.bgClassUtil.threeColorGradientClasses(colorName, index)} ${this.borderRadius} ${this.fontWeight}`
        },
        threeColorGradientClasses2(colorName, index) {
            return `${this.gradientDirection} ${this.bgClassUtil.threeColorGradientClasses2(colorName, index)} ${this.borderRadius} ${this.fontWeight}`
        },
        onBorderSelected() {
            this.borderRadius = this.selectedBorderOption === 'DEFAULT' ? 'rounded' : `rounded-${this.selectedBorderOption}`
        },
        onFontWeightSelected() {
            this.fontWeight = `font-${this.selectedFontWeightOptions}`
        },
        onGradientSelected() {
            this.gradientDirection = `bg-${this.selectedGradientOption}`
        },
        // plus2(index) {
        //     return (index + 2) % this.colorNames.length
        // },
        // plus4(index) {
        //     return (index + 5) % this.colorNames.length
        // },
        // nextIndex(index) {
        //     return (index + 1) % this.colorNames.length
        // },
        // nextIndex2(index) {
        //     return this.plus2(index)
        // }
    }
}
</script>
